// extracted by mini-css-extract-plugin
export default {"billIcon":"hSCFdNUWyXHnayM1Qax9","placeHolderShimmer":"lLixTwFwyAPP7cq1MdVT"};